module.exports = __webpack_public_path__ + "media/images/menu-icons/shop-products-027d0a607f197af75b16661ba70312ab.svg";